import { render } from "./HomeownerWelcomeComponent.vue?vue&type=template&id=5b5f42d6&scoped=true&ts=true"
import script from "./HomeownerWelcomeComponent.vue?vue&type=script&lang=ts"
export * from "./HomeownerWelcomeComponent.vue?vue&type=script&lang=ts"

import "./HomeownerWelcomeComponent.vue?vue&type=style&index=0&id=5b5f42d6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b5f42d6"]])

export default __exports__